import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getHubsSignupCTA } from 'pricing-pages-lib/utils/publicPageUrls';
import { useValidatedCrmSuiteQueryParamTerm } from 'pricing-pages-ui/utils/urls/queryParamUtils';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { ProductLevelToSuiteNonMerchandiseIdMap } from 'pricing-pages-lib/constants/NonMerchandiseIdProducts';
import { LEARN_MORE } from 'pricing-pages-lib/constants/CtaTypes';
import MobileSuiteCatalogModal from './crm-suite-catalog/MobileSuiteCatalog';
import { SUITE_CARD } from '../../../constants/tracking/Locations';

const MobileSuiteViewAllFeatures = ({
  productLevel,
  currencyCode
}) => {
  const [isModalOpen, setIsModalOpen] = useState(productLevel === STARTER && getQueryParams().viewStarterFeatures === 'true');
  const gaClassName = getHubsSignupCTA({
    ctaType: LEARN_MORE,
    nonMerchandiseIdProduct: ProductLevelToSuiteNonMerchandiseIdMap[productLevel],
    sourceId: 'pricing-features'
  });

  const toggleViewAllFeaturesModal = () => {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      getUsageTracker().track('clickToViewModal', {
        name: 'compare-feature-modal',
        productLevel,
        location: SUITE_CARD
      });
    }
  };

  const {
    queryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      className: `m-left-0 ${gaClassName}`,
      onClick: toggleViewAllFeaturesModal,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: gaClassName,
        message: "suiteFeatureTable.mobile.seeAll"
      })
    }), isModalOpen && /*#__PURE__*/_jsx(MobileSuiteCatalogModal, {
      initialProductLevel: productLevel,
      queryParamTerm: queryParamTerm,
      onCloseClick: toggleViewAllFeaturesModal,
      currencyCode: currencyCode
    })]
  });
};

export default MobileSuiteViewAllFeatures;